import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Componentes existentes
import App from "./App";
import Activar from "./components/Activar";
import Consultar from "./components/Consultar";
import AdminOperativo from "./admin/AdminOperativo/AdminOperativo";
import DeployHistory from "./admin/DeployHistory/DeployHistory";
import SolicitudesUpgrade from "./admin/SolicitudesUpgrade/SolicitudesUpgrade";
import MktPanel from "./admin/MktPanel/MktPanel";
import Verificar from "./components/Verificar";
import VerificarSiguiente from "./components/VerificarSiguiente";
import UserPanelLoader from "./userPanel/components/UserPanelLoader";
import ScanPage from "./userPanel/components/ScanPage";
import Gracias from "./components/gracias";
import VetPanel from "./vetPanel/VetPanel"; 
import VetLoginPage from "./vetPanel/VetLoginPage";
import VetPatientsScreen from "./vetPanel/components/VetPatientsScreen";
import VetDisponibilidadConfig from "./vetPanel/components/VetDisponibilidadConfig";
import VetPerfilProfesional from "./vetPanel/components/VetPerfilProfesional";
import VetPanelSeguimiento from "./vetPanel/components/VetPanelSeguimiento";
import VetAtenderCita from "./vetPanel/components/VetAtenderCita";
import UserCalendarCitas from "./userPanel/components/UserCalendarCitas"; 
import ExpedienteClinicoPanel from "./expedientePanel/ExpedienteClinicoPanel";
import Dashboard from './pages/Dashboard';
import UserLogin from "./pages/UserLogin";
import ProviderVerification from "./components/ProviderVerification";
import ReenviarVerificacion from './pages/ReenviarVerificacion';
import CompartirCartillaPage from "./pages/CompartirCartillaPage";
import TratamientoDashboard from "./tratamientos/TratamientoDashboard";
import TratamientoPublico from "./publicPages/TratamientoPublico";
import PerfilBusqueda from "./publicPages/PerfilBusqueda";
import EditarNegocio from "./publicPages/EditarNegocio";
import RecordatoriosCompartidos from "./publicPages/RecordatoriosCompartidos";
import GoogleCalendarCallback from "./pages/GoogleCalendarCallback";

// ===== LOCALIZADOR DE SERVICIOS =====
import {
  LocalizadorGlobal,
  LocalizadorMascota,
  LocalizadorObjeto,
  LocalizadorResultados,
  LocalizadorDetalle,
  LocalizadorFavoritos
} from "./localizador/pages";


// ===== PASO 1: IMPORTAR LOS NUEVOS COMPONENTES =====
import Privacidad from "./pages/Privacidad";
import Terminos from "./pages/Terminos";
import Validacion from "./pages/Validacion";
import DocumentoPublico from "./components/DocumentoPublico";
import ExpedientePublico from "./components/ExpedientePublico";


export default function MainRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Ruta raíz */}
        <Route path="/" element={<App />} />

        {/* Otras rutas */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin-ops" element={<AdminOperativo />} />
        <Route path="/deploy-history" element={<DeployHistory />} />
        <Route path="/admin-ops/solicitudes-upgrade" element={<SolicitudesUpgrade />} />
        <Route path="/mkt-panel" element={<MktPanel />} />
        <Route path="/activar" element={<Activar />} />
        <Route path="/consultar" element={<Consultar />} />
        <Route path="/verificar" element={<Verificar />} />
        <Route path="/verificarSiguiente" element={<VerificarSiguiente />} />
        <Route path="/verificar-proveedor" element={<ProviderVerification />} />
        <Route path="/userpanel" element={<UserPanelLoader />} />
        <Route path="/scan" element={<ScanPage />} />
        <Route path="/gracias" element={<Gracias />} />
        <Route path="/vetPanel" element={<VetPanel />} />
        <Route path="/vetLogin" element={<VetLoginPage />} />
        <Route path="/vetPanel/pacientes" element={<VetPatientsScreen />} />
        <Route path="/vetPanel/calendarDisponibilidad" element={<VetDisponibilidadConfig />} />
        <Route path="/vetPanel/perfil" element={<VetPerfilProfesional />} />
        <Route path="/vetPanel/seguimiento" element={<VetPanelSeguimiento />} />
        <Route path="/vetPanel/atender/:citaId" element={<VetAtenderCita />} />
        <Route path="/userCalendarCitas" element={<UserCalendarCitas />} />
        <Route path="/expedienteClinico" element={<ExpedienteClinicoPanel />} />
        <Route path="/cartilla" element={<CompartirCartillaPage />} />
        <Route path="/tratamientos/:id" element={<TratamientoDashboard />} />
        <Route path="/login" element={<UserLogin />} />

        {/* ===== PASO 2: AÑADIR LAS NUEVAS RUTAS ===== */}
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/reenviar-verificacion" element={<ReenviarVerificacion />} />
        <Route path="/validacion" element={<Validacion />} />

        {/* Ruta pública para ver documentos compartidos */}
        <Route path="/d/:token" element={<DocumentoPublico />} />

        {/* Ruta pública para ver cartilla de vacunación compartida */}
        <Route path="/expediente/:token" element={<ExpedientePublico />} />

        {/* Ruta pública para ver progreso de tratamiento via QR */}
        <Route path="/tratamiento-publico/:id" element={<TratamientoPublico />} />

        {/* Ruta pública para ver perfil de búsqueda de mascota/objeto perdido */}
        <Route path="/perdido/:id" element={<PerfilBusqueda />} />

        {/* Ruta pública para editar negocio con token temporal */}
        <Route path="/editar-negocio/:token" element={<EditarNegocio />} />

        {/* Google Calendar OAuth callback */}
        <Route path="/auth/google-calendar/callback" element={<GoogleCalendarCallback />} />

        {/* Ruta pública para descargar recordatorios compartidos como .ics */}
        <Route path="/compartido/recordatorios/:token" element={<RecordatoriosCompartidos />} />

        {/* ===== LOCALIZADOR DE SERVICIOS ===== */}
        <Route path="/localizador" element={<LocalizadorGlobal />} />
        <Route path="/localizador/mascota/:perfilId" element={<LocalizadorMascota />} />
        <Route path="/localizador/objeto/:perfilId" element={<LocalizadorObjeto />} />
        <Route path="/localizador/resultados/:categoria" element={<LocalizadorResultados />} />
        <Route path="/localizador/lugar/:lugarId" element={<LocalizadorDetalle />} />
        <Route path="/localizador/favoritos" element={<LocalizadorFavoritos />} />

        {/* Ruta 404 opcional */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </BrowserRouter>
  );
}